export function findCompanyById(companies, selectedCompanyId) {
  const accountId = String(selectedCompanyId || '').trim();
  if (!accountId || !Array.isArray(companies)) return null;
  return companies.find((company) => String(company?._id) === accountId) || null;
}

export function buildCompanyOptions(companies) {
  if (!Array.isArray(companies)) return [];
  return companies
    .filter((company) => company?._id !== undefined && company?._id !== null)
    .map((company) => ({
      value: String(company._id),
      label: `${company.company_name} (${company._id})`,
    }));
}
